import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { id: "main" }
const _hoisted_2 = { class: "sec-main appointmentP-main" }
const _hoisted_3 = { class: "container-lg" }
const _hoisted_4 = { class: "col-sm-10 mx-auto" }
const _hoisted_5 = {
  style: {"--bs-breadcrumb-divider":"'>'"},
  "aria-label": "breadcrumb"
}
const _hoisted_6 = { class: "breadcrumb" }
const _hoisted_7 = { class: "breadcrumb-item" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("li", {
  class: "breadcrumb-item active",
  "aria-current": "page"
}, "創業工具 - 預約諮詢", -1)
const _hoisted_9 = { class: "row head-row" }
const _hoisted_10 = { class: "col-12 col-sm-10 mx-auto" }
const _hoisted_11 = { class: "appointment-board bg-gray" }
const _hoisted_12 = { class: "appointment-board-wrapper" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h1", { class: "h2 n text-primary mb-4" }, "預約諮詢", -1)
const _hoisted_14 = { class: "mb-5" }
const _hoisted_15 = { class: "mb-4" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("h2", { class: "h3 mb-1" }, "姓名", -1)
const _hoisted_17 = { class: "h4 pre-text" }
const _hoisted_18 = { class: "mb-4" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("h2", { class: "h3 mb-1" }, "電話/手機", -1)
const _hoisted_20 = { class: "h4 pre-text" }
const _hoisted_21 = { class: "mb-4" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("h2", { class: "h3 mb-1" }, "Email", -1)
const _hoisted_23 = { class: "h4 pre-text" }
const _hoisted_24 = { class: "mb-5" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", {
  for: "qaType",
  class: "form-label text-black mb-4"
}, "問題分類", -1)
const _hoisted_26 = { class: "h4 pre-text" }
const _hoisted_27 = { class: "mb-4 mb-md-5" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", {
  for: "qaMsg",
  class: "form-label text-black mb-4"
}, "諮詢問題簡述(300字以內)", -1)
const _hoisted_29 = { class: "h4 pre-text" }
const _hoisted_30 = {
  class: "fccc",
  style: {"flex-direction":"unset"}
}
const _hoisted_31 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!
  const _directive_title = _resolveDirective("title")!
  const _directive_body_class = _resolveDirective("body-class")!

  return _withDirectives((_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("nav", _hoisted_5, [
            _createElementVNode("ol", _hoisted_6, [
              _createElementVNode("li", _hoisted_7, [
                _createVNode(_component_router_link, {
                  to: "/",
                  title: "首頁",
                  class: "foo: false"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("首頁")
                  ]),
                  _: 1
                })
              ]),
              _hoisted_8
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _createVNode(_component_Form, { onSubmit: _ctx.submit }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _hoisted_16,
                        _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.form.name), 1)
                      ]),
                      _createElementVNode("div", _hoisted_18, [
                        _hoisted_19,
                        _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.form.mobile), 1)
                      ]),
                      _createElementVNode("div", _hoisted_21, [
                        _hoisted_22,
                        _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.form.email), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_24, [
                      _hoisted_25,
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.$t('appointment.' + _ctx.form.category)), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_27, [
                      _hoisted_28,
                      _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.form.content), 1)
                    ]),
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("button", {
                        class: "btn-primay filled",
                        disabled: _ctx.disableButton
                      }, "送出", 8, _hoisted_31),
                      _createElementVNode("button", {
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.backEdit())),
                        type: "button",
                        class: "ms-1 btn-primay filled"
                      }, "重新修改")
                    ])
                  ]),
                  _: 1
                }, 8, ["onSubmit"])
              ])
            ])
          ])
        ])
      ])
    ])
  ])), [
    [_directive_title, '預約諮詢'],
    [_directive_body_class, 'appointmentP']
  ])
}